import { Injectable } from "@angular/core";
import { BackendService } from "./common/backend.service";
import { HttpErrorHandlerService } from "./common/http-error-handler.service";

type CriticalPointAiResponse = {
  results: string[];
};

@Injectable({
  providedIn: "root",
})
export class CriticalPointAiService {

  private readonly rewriteEndpoint = "/api/admin/ai/critical-point/rewrite";

  constructor(
    private backendService: BackendService,
    private httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  /**
   * Requests the AI service to rewrite a critical point description.
   *
   * @param description the description that should be rewritten
   * @param image optional base64 encoded image
   * @returns the rewritten description or undefined if the request failed
   */
  public async rewriteCriticalPointDescription(
    description: string,
    image?: string
  ): Promise<string[] | undefined> {
    try {
      const response: CriticalPointAiResponse = await this.backendService.callApi(
        this.rewriteEndpoint,
        "POST",
        { description, image }
      );
      return response.results;
    } catch (error: any) {
      this.httpErrorHandlerService.handleError(
        error,
        "Hiba a kritikus pont leírásának átfogalmazása közben."
      );
      return undefined;
    }
  }
}
